import React, { ReactNode } from 'react'
import { v4 as uuidV4 } from 'uuid'
import { notification } from 'antd'

export const openValidationPopup = (
  title: string | ReactNode,
  description: string | ReactNode
) => {
  openPopup(title, description, 5, 'success')
}

export const openErrorPopup = (
  title: string | ReactNode,
  description: string | ReactNode
) => {
  openPopup(title, description, 0, 'error')
}

export const openPopup = (
  title: string | ReactNode,
  description: string | ReactNode,
  duration?: number,
  type?: 'success' | 'error' | 'info' | 'warning'
) => {
  const key = uuidV4()

  notification[type || 'info']({
    key,
    message: title,
    description: description,
    duration: duration || 0,
  })
  return key
}

export const closePopup = (key: React.Key) => {
  notification.destroy(key)
}
